/* eslint-disable */
export default {
  order: 1,
  header: [
    {
      category: 'Overview',
      item: [
        {
          title: '',
          list: [
            {
              name: 'What is EnOS',
              url: '/docs/enos/en/preview/overview/enos_introduction.html'
            },
            {
              name: 'EnOS Advantages',
              url: '/docs/enos/en/preview/overview/advantage.html'
            },
            {
              name: 'Key Concepts',
              url: '/docs/enos/en/preview/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: 'Product Documentation',
      item: [
        {
          title: 'Application Building',
          list: [
            {
              name: 'Digital Twin Visualization',
              url: '/docs/dtv/en/preview/overview.html'
            },
            {
              name: 'Unified Monitoring',
              url: '/docs/monitor/en/preview/overview/monitor_overview.html'
            },
            {
              name: 'Reporting Tool',
              url: '/docs/reporting/en/preview/overview.html'
            },
            {
              name: 'Alarm Management',
              url: '/docs/alarm-management/en/preview/overview/about.html'
            },
            {
              name: 'Alert Engine',
              url: '/docs/alert/en/preview/learn/alert_overview.html'
            },
            {
              name: 'Work Management',
              url: '/docs/wmt/en/preview/about.html'
            },
            {
              name: 'Notification Management ',
              url: '/docs/notification-mgmt/en/preview/notification_center_overview.html'
            },
            {
              name: 'Application Portal',
              url: '/docs/app-portal/en/preview/overview.html'
            }
          ]
        },
        {
          title: 'Data Management and Analytics',
          list: [
            {
              name: 'Data Subscription',
              url: '/docs/data-subscription/en/preview/data_subscription_overview.html'
            },
            {
              name: 'Data Archiving',
              url: '/docs/data-archiving/en/preview/archive_policy.html'
            },
            {
              name: 'Data Source Registration',
              url: '/docs/data-source-reg-app/en/preview/datasource_overview.html'
            },
            {
              name: 'Model Management',
              url: '/docs/modelling-tool/en/preview/overview/about.html'
            }
          ]
        },
        {
          title: 'Device Connectivity and Management',
          list: [
            {
              name: 'Device Connection',
              url: '/docs/device-connection/en/preview/learn/message_flow.html'
            },
            {
              name: 'Device Data Integration Service',
              url: '/docs/device-integration/en/preview/learn/device_integration_overview.html'
            },
            {
              name: 'Device Management',
              url: '/docs/device-connection/en/preview/learn/device_lifecycle_management.html'
            },
            {
              name: 'Data Quality',
              url: '/docs/data-quality/en/preview/overview/about.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: 'View all products',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/en/preview'
      },
      showListInMobile: false
    },
    {
      category: 'Tutorials',
      item: [
        {
          title: 'Data Integration',
          list: [
            {
              name: 'Connecting a Simulated Device to EnOS Cloud',
              url: '/docs/device-connection/en/preview/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: 'Connecting a Simulated Electricity Meter to EnOS Edge',
              url: '/docs/enos-edge/en/2.4.4/tutorial/connecting_edge.html'
            },
            {
              name: 'Integrating PC Device Data',
              url: '/docs/device-integration/en/preview/howto/tutorial_pc_device_mgmt.html'
            }
          ]
        },
        {
          title: 'Data Development',
          list: [
            {
              name: 'Assessing Data Quality of the Wind Turbine',
              url: '/docs/data-quality/en/preview/tutorial.html'
            },
            {
              name: 'Developing Metrics of Solar Generation, Temperature, and Radiance',
              url: '/docs/metric-management/en/preview/tutorial/index.html'
            },
            {
              name: 'Customizing Production(SPLM) Metric for Solar Sites',
              url: '/docs/cds/en/preview/tutorial/tutorial_solar.html'
            }
          ]
        },
        {
          title: 'Application Development',
          list: [
            {
              name: 'Creating Applications Using Common Building Blocks',
              url: '/docs/app-development/en/preview/app_dev_workflow/index.html'
            },
            {
              name: 'Building a Smart Battery Dashboard',
              url: '/docs/dtv/en/preview/tutorial/index.html'
            },
            {
              name: 'Building a Water Purification System Monitoring Page',
              url: '/docs/dtv/en/preview/tutorial/monitor.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: 'View all tutorials',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/en/preview/tutorial'
      },
      showListInMobile: false
    },
    {
      category: 'Resources',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/enos-apis/'
            },
            {
              name: 'SDKs and Tools',
              url: 'https://developer.enos-iot.com/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: {
    Cards: [
      {
        name: 'EnOS 101',
        description: 'Learn about the advantages and key concepts of EnOS.',
        image: 'assets/images/landing/cards/started_information.svg',
        url: '/docs/enos/en/preview/overview/enos_introduction.html'
      },
      {
        name: 'Tutorials',
        description: 'Explore step-by-step walkthroughs of core scenarios to quickly get started with EnOS.',
        image: 'assets/images/landing/cards/tutorial.svg',
        url: '/docs/en/preview/tutorial'
      },
      {
        name: 'Release Notes',
        description: 'Check out EnOS release notes.',
        image: 'assets/images/landing/cards/version_description.svg',
        url: '/docs/enos/en/preview/releasenotes/index.html'
      },
      {
        name: 'EnOS APIs',
        description: 'Leverage Open APIs to access EnOS resources and develop diverse applications easily.',
        image: 'assets/images/landing/cards/api_reference.svg',
        url: '/docs/api/en/preview/overview.html'
      },
      {
        name: 'SDKs and Tools',
        description: 'Obtain EnOS SDKs and tools and develop applications based on EnOS.',
        image: 'assets/images/landing/cards/sdk_tools.svg',
        url: 'https://developer.enos-iot.com/enos-sdks-tools/'
      }
    ],
    Products: [
      {
        category: 'Application Building',
        item: [
          {
            name: 'Digital Twin Visualization',
            image: 'assets/images/landing/products/digital_twin_visualization.svg',
            url: '/docs/dtv/en/preview/overview.html'
          },
          {
            name: 'Unified Monitoring',
            image: 'assets/images/landing/products/unified_monitoring.svg',
            url: '/docs/monitor/en/preview/overview/monitor_overview.html'
          },
          {
            name: 'Reporting Tool',
            image: 'assets/images/landing/products/reporting_tool.svg',
            url: '/docs/reporting/en/preview/overview.html'
          },
          {
            name: 'Alarm Management',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/alarm-management/en/preview/overview/about.html'
          },
          {
            name: 'Alert Engine',
            image: 'assets/images/landing/products/alert_management.svg',
            url: '/docs/alert/en/preview/learn/alert_overview.html'
          },
          {
            name: 'Work Management',
            image: 'assets/images/landing/products/work_management.svg',
            url: '/docs/wmt/en/preview/about.html'
          },
          {
            name: 'Notification Management',
            image: 'assets/images/landing/products/schedule_management.svg',
            url: '/docs/notification-mgmt/en/preview/notification_center_overview.html'
          },
          {
            name: 'Application Portal',
            image: 'assets/images/landing/products/application_portal.svg',
            url: '/docs/app-portal/en/preview/overview.html'
          }
        ]
      },
      {
        category: 'Data Management and Analytics',
        item: [
          {
            name: 'Data Subscription',
            image: 'assets/images/landing/products/data_subscription.svg',
            url: '/docs/data-subscription/en/preview/data_subscription_overview.html'
          },
          {
            name: 'Data Archiving',
            image: 'assets/images/landing/products/data_source_registration.svg',
            url: '/docs/data-archiving/en/preview/archive_policy.html'
          },
          {
            name: 'Data Source Registration',
            image: 'assets/images/landing/products/data_source_registration 2.svg',
            url: '/docs/data-source-reg-app/en/preview/datasource_overview.html'
          },
          {
            name: 'Model Management',
            image: 'assets/images/landing/products/enos_mobile.svg',
            url: '/docs/modelling-tool/en/preview/overview/about.html'
          }
        ]
      },
      {
        category: 'Device Connectivity and Management',
        item: [
          {
            name: 'Device Connection',
            image: 'assets/images/landing/products/device_connectivity.svg',
            url: '/docs/device-connection/en/preview/learn/message_flow.html'
          },
          {
            name: 'Device Data Integration Service',
            image: 'assets/images/landing/products/device_data_integration_service.svg',
            url: '/docs/device-integration/en/preview/learn/device_integration_overview.html'
          },
          {
            name: 'Device Management',
            image: 'assets/images/landing/products/device_management.svg',
            url: '/docs/device-connection/en/preview/learn/device_lifecycle_management.html'
          },
          {
            name: 'Data Quality',
            image: 'assets/images/landing/products/data_quality.svg',
            url: '/docs/data-quality/en/preview/overview/about.html'
          },
          {
            name: 'EnOS Edge',
            image: 'assets/images/landing/products/device_provisioning_service.svg',
            url: '/docs/enos-edge/en/2.4.4/edge_overview.html'
          }
        ]
      }
    ]
  }
};
